export const generateImageUrl = (imageId: string) => {
  return process.env.REACT_APP_ASSETS_URL + '/' + imageId;
}

export const generateThumbnailUrl = (imagePath: string) => {
  return process.env.REACT_APP_ASSETS_STORAGE_URL + '/' + imagePath;
}